var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0H12.5V1.66667H4.16667V0H2.5V1.66667H0V16.6667H16.6667V1.66667H14.1667V0ZM5 13.3333H3.33333V11.6667H5V13.3333ZM5 10H3.33333V8.33333H5V10ZM9.16667 13.3333H7.5V11.6667H9.16667V13.3333ZM9.16667 10H7.5V8.33333H9.16667V10ZM9.16667 6.66667H7.5V5H9.16667V6.66667ZM13.3333 10H11.6667V8.33333H13.3333V10ZM13.3333 6.66667H11.6667V5H13.3333V6.66667Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.d5ab7e552f80ec14d8c52567806cbc6d.svg";
export { ForwardRef as ReactComponent };